import { api } from "./api";

/** Download a binary endpoint as a file. Uses the same withCredentials auth as `api`. */
export async function downloadFile(endpoint, fallbackName = "report.xlsx") {
  const res = await api.get(endpoint, { responseType: "blob" });
  // Try to extract filename from Content-Disposition
  let filename = fallbackName;
  const cd = res.headers["content-disposition"];
  if (cd) {
    const m = cd.match(/filename="?([^";]+)"?/);
    if (m) filename = m[1];
  }
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
